export default {
    userType: {
        1: 'Admin',
        2: 'Warehouse',
        3: 'Logistic',
        4: 'Retail Store',
        5: 'Office',
        6: 'Purchaser',
    },
    customerType: {
        2: 'Warehouse',
        3: 'Logistic',
        4: 'Retail Store',
    },
    locationType: {
        1: 'Warehouse',
        2: 'Logistic',
        3: 'Retail Store',
    },
    statusType: {
        0: 'Active',
        1: 'Inactive',
    },
    movementStatus: {
        0: 'Pending',
        1: 'Confirmed',
        2: 'Declined',
        3: 'Cancelled',
        4: 'Completed',
    },
    iceType: {
        1: 'Received',
        2: 'Sold',
        3: 'Return',
        4: 'Stock In',
        5: 'Stock Out',
    },
    iceTypeCol: {
        1: '<span className="text-blue">Received</span>',
        2: '<span className="text-red">Sold</span>',
        3: '<span className="text-purple">Return</span>',
        4: '<span className="text-orange">Stock In</span>',
        5: '<span className="text-orange">Stock Out</span>',
    },
    returnStatus: {
        0: 'Pending',
        1: 'Confirmed',
        2: 'Declined',
        3: 'Disposed',
    },
    paymentType: {
        0: 'Cash',
        1: 'Cheque',
    },
    numbersonly(e) {
        let key;
        let ret;

        if (window.event) {
            key = window.event.keyCode;
        } else if (e) {
            key = e.which;
        } else {
            ret = true;
        }
        const keychar = String.fromCharCode(key);

        // control keys
        if (key === null || key === 0 || key === 8 || key === 9 || key === 13 || key === 27) {
            ret = true;
        } else if ((('0123456789.').indexOf(keychar) > -1)) { // numbers, dot
            ret = true;
        } else {
            ret = false;
        }

        return ret;
    },
    createMarkup(string) {
        return { __html: string };
    },
    numberFormat(value, digits = 2) {
        return value.toLocaleString(navigator.language, { minimumFractionDigits: digits });
    },
    parseToNumber(value, type = 'int', radix = 10) {
        value = value.replace(/,/g, '');
        let retVal = parseInt(value, radix);
        const typeTxt = type.toString().toLowerCase();
        if (typeTxt === 'float') {
            retVal = parseFloat(value, radix);
        }
        return retVal;
    },
};
